export default __webpack_public_path__ + "static/ironing-stative-848d459ca8f772119f7aa3d3157875b2.svg";